import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Ag1ButtonBaseComponent } from '../ag1-button-base/ag1-button-base.component';
import { NgClass } from '@angular/common';
import { Ag1TooltipDirective } from '../../directives/tooltip.directive';
import { SentenceCasePipe } from '../../pipes/sentence.pipe';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-button' instead.
 */
@Component({
  selector: 'ag1-button',
  templateUrl: './ag1-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, Ag1TooltipDirective, SentenceCasePipe],
})
export class Ag1ButtonComponent extends Ag1ButtonBaseComponent {
  // logic implemented inside Ag1ButtonBaseComponent
}
